import { TableHeader, type TableHeaderRow } from '@shared/table-generator';

function getBankStructureDashBoardTableHeader(): TableHeaderRow[] {
  return [
    {
      children: [
        {
          id: 'subject',
          children: 'วิชา',
          align: 'center',
          rowSpan: 2,
        },
        {
          id: 'calculated',
          children: 'คำนวณ',
          align: 'center',
          colSpan: 3,
          sx: {
            py: (theme) => theme.spacing(2),
          },
        },
        {
          id: 'not-calculated',
          children: 'ไม่คำนวณ',
          align: 'center',
          colSpan: 3,
          sx: {
            py: (theme) => theme.spacing(2),
          },
        },
        {
          id: 'total',
          children: 'รวม',
          align: 'center',
          rowSpan: 2,
          className: 'total-column',
          width: 112,
        },
      ],
    },
    {
      children: [
        {
          children: 'ง่าย',
          align: 'center',
          width: 60,
          sx: {
            py: (theme) => theme.spacing(2),
          },
        },
        {
          children: 'กลาง',
          align: 'center',
          width: 60,
          sx: {
            py: (theme) => theme.spacing(2),
          },
        },
        {
          children: 'ยาก',
          align: 'center',
          width: 60,
          sx: {
            py: (theme) => theme.spacing(2),
          },
        },
        {
          children: 'ง่าย',
          align: 'center',
          width: 60,
          sx: {
            py: (theme) => theme.spacing(2),
          },
        },
        {
          children: 'กลาง',
          align: 'center',
          width: 60,
          sx: {
            py: (theme) => theme.spacing(2),
          },
        },
        {
          children: 'ยาก',
          align: 'center',
          width: 60,
          sx: {
            py: (theme) => theme.spacing(2),
          },
        },
      ],
    },
  ];
}
export default function QBankStructureDashBoardTableHeader() {
  const columns = getBankStructureDashBoardTableHeader();
  return (
    <TableHeader
      columns={columns}
      slotProps={{
        tableHeaderRow: {
          sx: {
            border: 'none',
          },
        },
        tableHeaderCell: {
          sx: (theme) => ({
            ...theme.typography.body1Semibold,
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.grey[100],
            padding: theme.spacing(3),
            borderColor: theme.palette.grey[300],
            borderRight: `1px solid ${theme.palette.grey[300]}`,
            '&.total-column': {
              borderRight: 'none',
            },
          }),
        },
      }}
    />
  );
}
